import { Select } from 'antd'
import { useAppContext } from '@/context/app-context'
import PermissionTag from '@/app/components/mlops/PermissionTag'
import { permissionMap } from '@/app/components/mlops/PermissionTag'
import { useEffect } from 'react'

type PermissionTypeProps = {
  value?: string
  onChange?: (value: string) => void
  defaultValue?: string
  disabled?: boolean
  allowAllUsers?: boolean
}

const PermissionType = ({
  value,
  defaultValue,
  onChange,
  disabled = false,
  allowAllUsers = true,
}: PermissionTypeProps) => {
  const { isSuper } = useAppContext()

  useEffect(() => {
    if (!value) {
      onChange?.('all_team_members')
    }
  }, [value, onChange])

  return (
    <Select
      value={value}
      defaultValue={defaultValue || 'only_me'}
      onChange={onChange}
      disabled={disabled}>
      {Object.keys(permissionMap).map(key => {
        if (!disabled && key === 'all_users' && !isSuper) return null
        return (
          <Select.Option key={key} value={key}>
            <PermissionTag value={key} />
          </Select.Option>
        )
      })}
    </Select>
  )
}

export default PermissionType
